// Configuração de instrutores da plataforma
// Centraliza os dados dos instrutores para facilitar manutenção

export const INSTRUCTORS = {
  'diane-andrade': {
    id: 'diane-andrade',
    name: 'Diane Andrade',
    title: 'Mentora',
    avatar: '/assets/images/diane-splash.png',
    bio: 'Fundadora da Major High Academy, uma pataforma de Educação Online para lideres e mentores crescerem em escala global',
    coursesCount: 1,
    studentsCount: 0,
    rating: 5.0
  },
  'roberto-andrade': {
    id: 'roberto-andrade',
    name: 'Roberto Andrade',
    title: 'Instrutor',
    avatar: '/assets/images/roberto-splash.jpeg',
    bio: 'Instrutor especializado em Inteligência Artificial e Inovação Tecnológica.',
    coursesCount: 0,
    studentsCount: 0,
    rating: 0
  }
};

/**
 * Obtém um instrutor pelo ID
 * @param {string} instructorId - ID do instrutor
 * @returns {Object|null} Dados do instrutor ou null se não encontrado
 */
export const getInstructorById = (instructorId) => {
  return INSTRUCTORS[instructorId] || null;
};

/**
 * Retorna todos os instrutores disponíveis
 * @returns {Array} Array com todos os instrutores
 */
export const getAllInstructors = () => {
  return Object.values(INSTRUCTORS);
};

/**
 * Obtém o instrutor padrão (Diane Andrade)
 * @returns {Object} Dados do instrutor padrão
 */
export const getDefaultInstructor = () => {
  return INSTRUCTORS['diane-andrade'];
};

/**
 * Obtém o instrutor para um curso, com fallback para o padrão
 * @param {string|null|undefined} instructorSlug - Slug do instrutor do curso
 * @returns {Object} Dados do instrutor
 */
export const getInstructorForCourse = (instructorSlug) => {
  if (instructorSlug) {
    const instructor = getInstructorById(instructorSlug);
    if (instructor) return instructor;
  }
  return getDefaultInstructor();
};

